//Reducer Types
interface State {
	list: any;
	count: number;
	detail: any;
}

interface UserListSuccess {
	type: "USER_LIST_SUCCESS";
	payload: {
		list: any;
		count: number;
		// detail: any;
	};
}
interface UserSearchSuccess {
	type: "USER_SEARCH_SUCCESS";
	payload: {
		list: any;
		count: number;
		// detail: any;
	};
}
interface UserDetails {
	type: "USER_DETAILS";
	payload: {
		list: any;
		count: number;
		detail: any;
	};
}
type Action = UserListSuccess | UserSearchSuccess | UserDetails;

export const userReducer = (
	state: State = {
		list: undefined,
		count: 0,
		detail: undefined,
	},
	action: Action
): State => {
	switch (action.type) {
		case "USER_LIST_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				// detail:action.payload.detail
			};
		case "USER_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				// detail:action.payload.detail
			};
		case "USER_DETAILS":
			return {
				...state,
				detail: action.payload.detail,
			};

		default:
			return state;
	}
};
